import { render, staticRenderFns } from "./CustomerRouterContainer.vue?vue&type=template&id=558a7b76&"
import script from "./CustomerRouterContainer.vue?vue&type=script&lang=js&"
export * from "./CustomerRouterContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2983364112/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('558a7b76')) {
      api.createRecord('558a7b76', component.options)
    } else {
      api.reload('558a7b76', component.options)
    }
    module.hot.accept("./CustomerRouterContainer.vue?vue&type=template&id=558a7b76&", function () {
      api.rerender('558a7b76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/CustomerRouterContainer.vue"
export default component.exports